import React from 'react';
import {
  Box,
  Grid,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';

const humanSkills = [
  {
    key: 'problem_solving',
    label: '問題解決能力',
    options: [
      '問題を特定する能力が乏しい',
      '簡単な問題を解決する際にサポートが必要',
      '一般的な問題を効率的に解決できる',
      '複雑な問題を分析し、効果的な解決策を提案できる',
      'チーム全体の問題解決をリードできる',
      '戦略的な問題解決を行い、組織全体に影響を与える'
    ]
  },
  {
    key: 'communication_skill',
    label: 'コミュニケーション能力',
    options: [
      '意思疎通が不十分で、誤解を招くことが多い',
      '基本的な指示や意見を伝えることができる',
      'チームメンバーと効果的にコミュニケーションできる',
      '複雑なアイデアや意見をわかりやすく伝えられる',
      'ステークホルダー間の橋渡し役として活躍できる',
      '高度な対人スキルで、組織全体のコミュニケーションを改善できる'
    ]
  },
  {
    key: 'autonomy_and_responsibility',
    label: '自律性と責任感',
    options: [
      '指示がないと行動できない',
      '指導の下でタスクを遂行する',
      '与えられた役割を責任を持って遂行できる',
      '自発的に行動し、業務を円滑に進める',
      '他人の業務も考慮に入れ、チーム全体に貢献できる',
      '組織の目標達成に向けて主体的にリードできる'
    ]
  },
  {
    key: 'learning_and_growth',
    label: '学習意欲と成長',
    options: [
      '新しい知識を学ぶ意欲が乏しい',
      '必要最低限の学習を行う',
      '業務に関連するスキルや知識を定期的に学んでいる',
      '自ら積極的に新しい技術や知識を習得する',
      '学んだ知識を応用し、チームに還元できる',
      '学習を通じて業界や組織に革新をもたらす'
    ]
  },
  {
    key: 'team_contribution',
    label: 'チームへの貢献度',
    options: [
      'チームにほとんど貢献できていない',
      '指示された範囲でチームに参加している',
      'チームの目標達成に一定の役割を果たしている',
      'チーム内で信頼され、積極的に協力している',
      'チームのパフォーマンス向上に貢献している',
      'チーム全体をリードし、成功に導いている'
    ]
  }
];

export default function HumanSkillForm({ formData, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...formData, [name]: value });
  };

  return (
    <Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        mb={3}
        sx={{
          fontSize: { xs: '1.25rem', sm: '1.5rem' }
        }}
      >
        ヒューマンスキル
      </Typography>

      <Grid container spacing={2}>
        {humanSkills.map((skill) => (
          <Grid item xs={12} key={skill.key}>
            <Box
              sx={{
                position: 'relative',
                border: '1px solid #ccc',
                borderRadius: 1,
                p: 2,
                mt: 3
              }}
            >
              <Typography
                sx={{
                  position: 'absolute',
                  top: '-12px',
                  left: '12px',
                  backgroundColor: 'white',
                  px: 1,
                  fontWeight: 'bold',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                }}
              >
                {skill.label}
              </Typography>

              <FormControl component="fieldset">
                <RadioGroup
                  id={skill.key}
                  name={skill.key}
                  value={formData[skill.key] || ''}
                  onChange={handleChange}
                >
                  {skill.options.map((desc, index) => (
                    <FormControlLabel
                      key={index}
                      value={`level_${index + 1}`}
                      control={<Radio />}
                      label={
                        <Typography
                          sx={{
                            fontSize: { xs: '0.75rem', sm: '0.875rem' }
                          }}
                        >
                          {desc}
                        </Typography>
                      }
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
